export default __webpack_public_path__ + "static/media/backBtn.2482fd5f.svg";